export enum TbdReasons {
    OrderTotal = 'order_total',
    LineItemTotal = 'line_item_total',
    MachineQuantity = 'machine_quantity',
    LeadTimeQuantity = 'lead_time_quantity',
    NonCad = 'non_cad',
}
